// Polna · koszyk motywu Shopify. Ten sam interfejs co prototyp (sklep-v1/src/assets/js/koszyk.js), ale dane z Ajax Cart API:
// POST /cart/add.js, POST /cart/change.js, GET /cart.js; mini-koszyk i strona koszyka odświeżane przez Section Rendering API
// (parametr sections w odpowiedzi add/change). Rejestr produktów (warianty, ceny, liczba tomów) osadza Liquid w <script data-polna-products>.
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const CFG = window.Polna || { routes: { root: '/', cart: '/cart', cart_add: '/cart/add', cart_change: '/cart/change' }, freeAmount: 150, t: {} };
const fmt = n => n.toLocaleString('pl-PL', { maximumFractionDigits: 0, useGrouping: 'always' }).replace(/\u00a0|\u202f/g, '\u00a0');
export const zl = n => `${fmt(n)} zł`;
export const FREE_AMOUNT = CFG.freeAmount || 150;
export const SHIP = { paczkomat: 12, kurier: 15 };

let DATA = [];
try { DATA = JSON.parse($('script[data-polna-products]')?.textContent || '[]'); } catch { DATA = []; }
export const ready = Promise.resolve(DATA);
export const product = h => DATA.find(p => p.handle === h);
export const variant = (p, id) => p?.variants.find(v => String(v.id) === String(id)) || p?.variants[0];

let cart = null;
const subs = new Set();
export const onChange = f => subs.add(f);
const emit = () => subs.forEach(f => f(cart));

/* sekcje odświeżane po każdej zmianie: mini-koszyk zawsze, strona koszyka tylko na /cart */
const sectionIds = () => {
  const ids = ['cart-drawer'];
  $$('[data-cart-section]').forEach(el => { if (el.dataset.cartSection && !ids.includes(el.dataset.cartSection)) ids.push(el.dataset.cartSection); });
  return ids.slice(0, 5);
};
function applySections(sections) {
  if (!sections) return;
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  if (sections['cart-drawer']) {
    const doc = parse(sections['cart-drawer']), d = $('#drawer');
    for (const sel of ['[data-drawer-count]', '[data-ship]', '[data-drawer-list]', '[data-drawer-sum]']) {
      const a = $(sel, doc), b = d && $(sel, d); if (a && b) b.innerHTML = a.innerHTML;
    }
    const n = Number($('[data-drawer-n]', doc)?.dataset.drawerN || 0);
    $$('[data-need-items]', d || document).forEach(a => a.setAttribute('aria-disabled', String(!n)));
    setCount(n);
  }
  $$('[data-cart-section]').forEach(el => {
    const html = sections[el.dataset.cartSection]; if (!html) return;
    const fresh = $(`[data-cart-section="${el.dataset.cartSection}"]`, parse(html)); if (fresh) el.innerHTML = fresh.innerHTML;
  });
}
function setCount(n) {
  $$('[data-cart-count]').forEach(c => { c.textContent = n; });
  $$('[data-cart-open]').forEach(b => b.setAttribute('aria-label', (CFG.t.count || 'Koszyk, liczba produktów: {n}').replace('{n}', n)));
}
async function post(url, body) {
  const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  const j = await r.json();
  if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart');
  return j;
}
export async function refresh() {
  cart = await (await fetch(`${CFG.routes.cart}.js`, { headers: { Accept: 'application/json' } })).json();
  setCount(cart.item_count); emit(); return cart;
}

/* kolejka: dodawanie tomu i dodatków po kolei, bez wyścigu zapisów koszyka */
let queue = Promise.resolve();
const enqueue = fn => (queue = queue.then(fn, fn));

// selling_plan: prawdziwe ID planu z aplikacji subskrypcyjnej (liczba > 1000) idzie jako selling_plan;
// do czasu aplikacji częstotliwość trafia do właściwości pozycji „Subskrypcja” (hak zostaje w tym samym miejscu).
function planFields(p, selling_plan) {
  if (!selling_plan) return {};
  // co 28 dni: jedna częstotliwość = pierwszy plan grupy; liczba > 1000 to bezpośrednie ID planu
  const id = Number(selling_plan) > 1000 ? Number(selling_plan) : (p?.selling_plans?.[0] || null);
  return id ? { selling_plan: id } : { properties: { Subskrypcja: `co ${selling_plan} dni` } };
}
export function add({ handle, variant_id, quantity = 1, properties = {}, selling_plan = null }, { openDrawer = true } = {}) {
  const p = product(handle), v = variant(p, variant_id);
  const id = v?.id || variant_id; if (!id) return Promise.resolve();
  const pf = planFields(p, selling_plan);
  const item = { id, quantity, properties: { ...properties, ...(pf.properties || {}) } };
  if (pf.selling_plan) item.selling_plan = pf.selling_plan;
  return enqueue(async () => {
    try {
      const res = await post(`${CFG.routes.cart_add}.js`, { items: [item], sections: sectionIds().join(','), sections_url: location.pathname });
      applySections(res.sections); bump();
      await refresh();
      if (openDrawer) open(); else toast(`${CFG.t.added || 'Dodano do koszyka'}: ${p?.title || ''}`);
    } catch (e) { toast(e.message && e.message !== 'cart' ? e.message : (CFG.t.error || 'Nie udało się dodać do koszyka.')); }
  });
}
export function change(key, quantity) {
  return enqueue(async () => {
    try {
      const res = await post(`${CFG.routes.cart_change}.js`, { id: key, quantity: Math.max(0, Math.min(99, quantity)), sections: sectionIds().join(','), sections_url: location.pathname });
      cart = res; applySections(res.sections); setCount(res.item_count); emit();
    } catch (e) { toast(CFG.t.error || 'Nie udało się zmienić koszyka.'); }
  });
}
export const remove = key => change(key, 0);
export const items = () => cart?.items || [];

/* ---------- mini-koszyk (1:1 z prototypem: tło, panel, fokus w pułapce, Esc) ---------- */
let lastFocus = null;
const drawer = () => $('#drawer');
function open() {
  const d = drawer(), bg = $('.drawer-bg'); if (!d) return;
  lastFocus = document.activeElement;
  bg.hidden = false; requestAnimationFrame(() => { bg.classList.add('on'); d.classList.add('on'); });
  d.setAttribute('aria-hidden', 'false'); d.removeAttribute('inert'); d.focus({ preventScroll: true });
}
function close() {
  const d = drawer(), bg = $('.drawer-bg'); if (!d || !d.classList.contains('on')) return;
  bg.classList.remove('on'); d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); d.setAttribute('inert', '');
  setTimeout(() => { if (!d.classList.contains('on')) bg.hidden = true; }, 450);
  lastFocus?.focus?.({ preventScroll: true });
}
export { open as openDrawer, close as closeDrawer };
function bump() { $$('[data-cart-count]').forEach(c => { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); setTimeout(() => c.classList.remove('bump'), 350); }); }
let toastT;
export function toast(msg) { const t = $('[data-toast]'); if (!t) return; t.textContent = msg; t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('on'), 2200); }

document.addEventListener('click', e => {
  if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
  if (e.target.closest('[data-cart-close]')) { close(); return; }
  const q = e.target.closest('[data-q]');
  if (q) { e.preventDefault(); change(q.dataset.k, Number(q.dataset.qn) + Number(q.dataset.q)); return; }
  const rm = e.target.closest('[data-rm]'); if (rm) { e.preventDefault(); remove(rm.dataset.rm).then(() => toast(CFG.t.removed || 'Usunięto z koszyka')); return; }
  const a = e.target.closest('[data-add-handle]');
  if (a) { e.preventDefault(); add({ handle: a.dataset.addHandle, variant_id: a.dataset.variant, selling_plan: a.dataset.plan || null }); }
  const dis = e.target.closest('a[aria-disabled="true"]'); if (dis) e.preventDefault();
});
document.addEventListener('keydown', e => {
  const d = drawer(); if (!d || !d.classList.contains('on')) return;
  if (e.key === 'Escape') close();
  if (e.key === 'Tab') { // fokus zostaje w koszyku
    const f = $$('a[href], button:not([disabled])', d).filter(x => x.offsetParent !== null && x.getAttribute('aria-disabled') !== 'true');
    if (!f.length) return; const first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!d.contains(a) || a === d) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
});
window.PolnaCart = { add, change, remove, items, refresh, open, close, ready };
